export var ClimateActionIncludes = {
    category: true,
    responsible: true,
    actionArea: true,
    subcategory: {
        include: {
            category: {
                include: {
                    scope: true,
                },
            },
        },
    },
    location: true,
    businessUnit: true,
};
//# sourceMappingURL=ClimateAction.js.map